import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchCurrenciesInfo, fetchCurrenciesCrossRates } from 'actions';

import { useSelectorProps } from './useSelectorProps';

export const useConvertorCrossRatesData = () => {
  const dispatch = useDispatch();
  const selectorProps = useSelectorProps();

  useEffect(() => {
    dispatch(fetchCurrenciesInfo(selectorProps)).then(() =>
      dispatch(fetchCurrenciesCrossRates(selectorProps))
    );
  }, [dispatch, selectorProps]);
};

export default useConvertorCrossRatesData;
